<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="记录单号" name="record_number"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="会员手机号码" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="select" label="支付方式" name="payment_type" :options="paymentTypeOptions"></c-form-item>
					<c-form-item type="datetime" label="充值时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<!-- <c-form-item type="checkbox" label="支付状态" name="payment_state" :options="paymentStateOptions" ></c-form-item> -->
					<c-form-item type="checkbox" label="审批状态" name="check_state" :options="checkStateOptions" ></c-form-item>
				</c-form>
			</m-search>

				<c-table ref="table">
				<c-table-column
					label="记录单号"
					name="record_number"
					width="140"
				></c-table-column>

				<c-table-column
					label="审批状态"
					name="check_state"
					width="80"
				>
					<template v-slot="{data}">
						<span style="color:red" v-if="data.check_state==3">审批驳回</span>
						<span style="color:green" v-if="data.check_state==2">审批通过</span>
						<span style="color:gray" v-if="data.check_state==1">待审批</span>
					</template>
				</c-table-column>

				<c-table-column
					label="充值金额"
					name="money"
					width="100"
				>
					<template v-slot="{data}">
						<span>￥{{(data.money||0).toFixed(2)}}</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="交易状态"
					name="payment_state"
					width="80"
				>
		          <template v-slot="{data}">
		            <span style="color:green" v-if="data.payment_state==2">已支付</span>
		            <span style="color:gray" v-if="data.payment_state==1">待支付</span>
		          </template>
				</c-table-column> -->
				
				<c-table-column
					label="支付渠道"
					name="payment_type"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.payment_state==1">--</span>
						<span v-else>{{data.payment_type}}</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="会员信息"
                        name="user_manage_mobilephone"
                        width="230"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                            <span>{{data.nick_name||'--'}}({{data.user_manage_mobilephone||'--'}})</span>
                        </div>
                    </template>
                </c-table-column>

				<c-table-column
					label="三方支付单号"
					name="third_number"
					width="200"
				></c-table-column>

				<!-- <c-table-column
					label="充值时间"
					name="create_date"
					width="140"
				></c-table-column> -->

				<c-table-column
					label="充值时间"
					name="payment_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="微信发货状态"
					name="wx_delivery_state"
					width="110"
				>
                    <template v-slot="{data}">
                        <span v-if="data.check_state == 2 && data.payment_type == '微信' && data.third_number && data.wx_delivery_state == 1" style="color: red">待发货</span>
                        <span v-else-if="data.check_state == 2 && data.payment_type == '微信' && data.third_number && data.wx_delivery_state == 2" style="color: green">已发货</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
                    width="120"
                >
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/member_upgrade_record_detail/${data.id}`)">详情</c-table-button>
<!--
                        <c-button v-if="data.check_state == 2 && data.payment_type == '微信' && data.third_number && data.wx_delivery_state == 1" @click="send(data)">确认发货</c-button>
-->
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'm_member_upgrade',
		
		data() {
			return {
				incomeExpensesName:{
					1: '收入',
					2: '支出',
					3: '主体资金不变'
				},
				paymentTypeOptions: [
					{name: '微信',value: "微信"},
					{name: '银行转账',value: "银行转账"}
				],
				paymentStateOptions: [
					{name: '待支付',value: "1"},
					{name: '已支付',value: "2"}
				],
				checkStateOptions: [
					{name: '待审批',value: "1"},
					{name: '已审批',value: "2"},
					{name: '审批驳回',value: "3"}
				]
			}
		},

		computed: {
			...mapState(['systemConfig'])
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('member_upgrade_record_list.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},
		
		methods: {
			searchHandle(data) {
				data.payment_state = [2];
		        this.searchDate = data;
		        this.$refs.table.load({
					url: '/memb/upgrade/record/list',
					data
				});
			},
			exportJob() {
				this.$message({
					text: '功能开发中',
					icon: 'error'
				});
			},

            send(data){
                this.$confirm({
                    text: '是否确认对转账升级单【'+data.record_number+'】进行“发货”处理？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/memb/upgrade/send',
                            data: {
                                id: data.id
                            },
                            loading: true,
                            success: (data,s)=> {
                                this.$message({
                                    text: '发货通知已发送，结果可能稍有延迟，请至微信后台查询具体的发货结果'
                                });
                                //延迟刷新页面
                                setTimeout(() => {
                                    this.$refs.table.update();
                                }, 500);
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            }
		}
	}
</script>